import {Component, OnInit} from '@angular/core';
import {AuthService} from '../auth/auth.service';
import {Router} from '@angular/router';
import {AppConfigService} from '../config/app-config.service';
import {Toast} from '../dialog/alert/toastr/toast';
import {ToastType} from '../dialog/alert/toastr/toast-type.enum';
import {MessageService} from '../messages/message.service';
import {TranslateService} from '../shared/translate.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HtmlUtilsService} from "../html-utils/html-utils.service";

@Component({
  selector: 'app-site-map',
  templateUrl: './site-map.component.html',
  styleUrls: ['./site-map.component.scss']
})

export class SiteMapComponent implements OnInit {
  public data;
  public isLogged;
  highContrast = false;
  constructor(private authService: AuthService,
              private router: Router,
              private modalService: NgbModal,
              public appconfigService: AppConfigService,
              public messageService: MessageService,
              public translator: TranslateService,
              private htmlUtils: HtmlUtilsService) {
    this.highContrast = this.htmlUtils.contrast;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
      }
    });
  }

  ngOnInit(): void {
    this.authService.isLogged.subscribe(value => {
      this.isLogged = value;
    });

    this.data = this.appconfigService.siteMapConfig;
  }

  executeFunction(name: string): void {
    const component = this;
    component[name]();
  }

  login() {
    this.router.navigateByUrl('/login');
  }

  loginWithMessage() {
    this.messageService.add(
      new Toast(this.translator.translate('SiteMapComponent.warning.title'),
        this.translator.translate('SiteMapComponent.warning.message'), ToastType.WARNING));
    setTimeout(() => {
      this.router.navigateByUrl('/login');
    }, 3000);
  }

  resetPassword() {
    if (this.isLogged) {
      this.router.navigateByUrl('/account');
    } else {
      this.router.navigateByUrl('/reset-password');
    }
  }

  logout() {
    this.authService.logout();
  }

  register() {
    this.router.navigateByUrl('/register');
  }

  managerAccount() {
    this.router.navigateByUrl('/account');
  }

  main() {
    this.router.navigateByUrl('/');
  }

  queries() {
    this.router.navigateByUrl('/queries');
  }

  collections() {
    this.router.navigateByUrl('/collections');
  }

  browse() {
    this.router.navigateByUrl('/search/b');
  }

  institutions() {
    this.router.navigateByUrl('/institutions');
  }

  terms() {
    const lang = localStorage.getItem('LANGUAGE') ? localStorage.getItem('LANGUAGE').toLowerCase() : 'pl';
    window.open('https://omnis.bn.org.pl/assets/pdf/terms_' + lang + '.pdf', '_blank');
  }

  policy() {
    const lang = localStorage.getItem('LANGUAGE') ? localStorage.getItem('LANGUAGE').toLowerCase() : 'pl';
    window.open('https://omnis.bn.org.pl/assets/pdf/policy_' + lang + '.pdf', '_blank');
  }

  declaration() {
    const lang = localStorage.getItem('LANGUAGE') ? localStorage.getItem('LANGUAGE').toLowerCase() : 'pl';
    window.open('https://omnis.bn.org.pl/assets/pdf/accessibility_statement_' + lang + '.pdf', '_blank');
  }

  feedbackComponent() {
    this.modalService.open(this.appconfigService.modalClasses.get('FeedbackComponent'));
  }

}
